import { startOfDay, endOfDay } from 'date-fns';

export const InitialFilterHeader = {
  tcnCustomerId: '',
  environment: false,
  campaignId: '',
  userId: 'All',
  productId: '',
  variant: '',
  method: 'All',
  result: 'All',
  startDate: startOfDay(new Date()),
  endDate: endOfDay(new Date())
};